import gql from "graphql-tag";

export const ARTWORK_CATEGORY = gql`
  fragment ArtworkCategoryFields on ArtworkCategory {
    id
    title
    number: numberOfArtworks
    parentID
    children {
      id
      title
    }
    deletedAt
  }
  fragment ArtworkCategoryRecursive on ArtworkCategory {
    ...ArtworkCategoryFields
    children {
      ...ArtworkCategoryFields
      children {
        ...ArtworkCategoryFields
        children {
          ...ArtworkCategoryFields
          children {
            ...ArtworkCategoryFields
            children {
              ...ArtworkCategoryFields
              children {
                ...ArtworkCategoryFields
                children {
                  ...ArtworkCategoryFields
                  children {
                    ...ArtworkCategoryFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  query ($parentID: String, $page: Int, $userID: String) {
    artworkCategories(parentID: $parentID, page: $page, userID: $userID) {
      ...ArtworkCategoryRecursive
    }
  }
`;
